(function () {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('button[name="checkout"]');
    if (!button) return;

    var checkbox = document.getElementById('cart_agree');
    var error = document.getElementById('cart-terms-error');

    if (!checkbox || checkbox.checked) {
      if (error) error.hidden = true;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    error.hidden = false;
    checkbox.setAttribute('aria-invalid', 'true');
    checkbox.focus();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var button = event.submitter;
    if (!form.matches('#cart') &&
        !(button && button.name === 'checkout')) return;

    var checkbox = document.getElementById('cart_agree');
    var error = document.getElementById('cart-terms-error');

    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    error.hidden = false;
    checkbox.setAttribute('aria-invalid', 'true');
    checkbox.focus();
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.id !== 'cart_agree') return;

    var error = document.getElementById('cart-terms-error');

    if (error && event.target.checked) {
      error.hidden = true;
      event.target.setAttribute('aria-invalid', 'false');
    }
  });
})();